const STEP_INFO = {
  STATE_BEFORE_ACTIVATION: 0,
  STATE_READY_TO_RELEASE: 1,
  STATE_NEXT_UNFREEZE: 2,
  STATE_PROVE_ADDRESS: 3,
  STATE_INIT_NULL_BEFORE: 11,
  STATE_INIT_NULL_ACTIVE: 12,
};
export default STEP_INFO;
